import { render } from "./QuestionsToggle.vue?vue&type=template&id=c78954d4"
import script from "./QuestionsToggle.vue?vue&type=script&lang=js"
export * from "./QuestionsToggle.vue?vue&type=script&lang=js"
script.render = render

export default script